module.exports = __webpack_public_path__ + "img/icon_sportMenu_star.390f67fe.svg";